import sumoLogo from '../images/sumo_logo.png'
import { Button } from '../components/button'
import { useNavigate, useLocation } from 'react-router-dom'
import { Input } from '../components/input'
import { useState, useEffect } from 'react'
import { AuthLayout } from '../components/auth-layout'
import { Avatar } from '../components/avatar'
import { Heading } from '../components/heading'
import config from '../config.js'
import { useAlert } from "../components/customAlert";

export default function LinkGoogleAccount() {
	const { showAlert } = useAlert();
	const navigate = useNavigate();
	const { state } = useLocation();
	
	//error msg from gmc login process starts
	const location = useLocation();
    const query = new URLSearchParams(location.search);
    const err = query.get("err");
	const err_msg = query.get("msg");

	useEffect(() => {
        if (err === "true") {
            showAlert(err_msg || "Something went wrong!", "Error", "error", 3000);//show error message or default msg
			return;
        }
    }, [err,err_msg]);
	//error msg from gmc login process ends

	const [loading, setLoading] = useState(false);
	const handleClick = () => {	
		if (!state?.gmcEmail || state.gmcEmail.trim() === "") {      
			showAlert('Something went wrong!', "Error" , "error",6000); 	
			
			setTimeout(() => {
            	navigate('/account-setup');
        	}, 2000);
			
			return;        	
    	}

    	const url = `${config.apiPath}/gmc-setup/gconnect_shopping.php?gmc_email=${encodeURIComponent(state.gmcEmail)}`;
    	window.open(url, "", "width=500,height=350");
		/*setTimeout(() => {
			// After 5 seconds, navigate to new page
			navigate('/list-companies');
		}, 2000);*/
	};
	const handleSubmit = async (e) => {
		e.preventDefault(); // prevent page reload
	};
	
	return (

<AuthLayout>
	<div className="grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center">

		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-3">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-2xl py-3">Let's get you started</Heading>
		<Heading className="text-center !text-2xl py-3">How many Google Merchant Centers do you manage ?</Heading>
		<div className="flex justify-center space-x-4 py-3">
			<div class="px-[25px] flex items-center justify-center">
				{!loading && (
					<Button type="button"  onClick={handleClick} id="create_account" value="" 
					class="box-border leading-[inherit] relative text-[16px] text-center no-underline text-white bg-[#3074AD] cursor-pointer mx-[20px] my-[10px] px-[20px] py-[8px] rounded-[7px] border-[none]">Link Google Account</Button>
				)}
				{loading && (<div className="text-center w-10 h-10 border-4 border-black-500 border-t-transparent rounded-full animate-spin"></div>)}
			</div>
		</div>
	</div>
</AuthLayout>
);
}